import { CommonPagingResponse, ImageCloudHistory } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _ImageCloudHistoryService {
  public getImageCloudHistory(image_id: string, page: number) {
    return HttpService.get<CommonPagingResponse<ImageCloudHistory>>(
      `/image-cloud-history/${image_id}?page=${page}`
    );
  }
}

const ImageCloudHistoryService = new _ImageCloudHistoryService();

export default ImageCloudHistoryService;
